import { ALERT_STYLE, type AlertKind } from '../config/alerts';

/**
 * SVG twin of the map sprites in src/map/icons.ts (FloodIcons.swift): flash
 * flood kinds are black-outlined triangles with an optional pulsing halo, the
 * rest are circles with a black stroke; all carry an exclamation mark.
 */
export function AlertGlyph({ kind, size = 36, animated = false, className = '' }: { kind: AlertKind; size?: number; animated?: boolean; className?: string }) {
  const style = ALERT_STYLE[kind];
  if (style.shape === 'triangle') {
    return (
      <svg viewBox="0 0 44 44" width={size} height={size} className={`alert-glyph ${className}`} aria-hidden="true" focusable="false">
        {animated ? <circle cx="22" cy="22" r="17" fill="none" stroke={style.color} strokeWidth="2" className="alert-glyph-halo" /> : null}
        <polygon points="22,5 39.5,36 4.5,36" fill="#000" />
        <polygon points="22,11 35,33.5 9,33.5" fill={style.color} />
        <text x="22" y="31.5" textAnchor="middle" fontSize="15" fontWeight="900" fontFamily="-apple-system, Helvetica, Arial, sans-serif" fill="#000">
          !
        </text>
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 44 44" width={size} height={size} className={`alert-glyph ${className}`} aria-hidden="true" focusable="false">
      <circle cx="22" cy="22" r="17" fill={style.color} stroke="rgba(0,0,0,0.85)" strokeWidth="2" />
      <text x="22" y="30" textAnchor="middle" fontSize="22" fontWeight="900" fontFamily="-apple-system, Helvetica, Arial, sans-serif" fill="#000">
        !
      </text>
    </svg>
  );
}

export function GaugeDot({ color, size = 18 }: { color: string; size?: number }) {
  return <span className="gauge-dot" style={{ background: color, width: size, height: size }} aria-hidden="true" />;
}
